import { ABP, ListService, PagedResultDto, TrackByService } from '@abp/ng.core';
import { Confirmation, ConfirmationService } from '@abp/ng.theme.shared';
import { DateAdapter } from '@abp/ng.theme.shared/extensions';
import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { filter, finalize, switchMap, tap } from 'rxjs/operators';
import type {
  GetAssetEventsInput,
  AssetEventWithNavigationPropertiesDto,
} from '../../../proxy/asset-events/models';
import { AssetEventService } from '../../../proxy/asset-events/asset-event.service';
import { AssetWithNavigationPropertiesDto } from '../../../proxy/assets';
import { AssetEventsModalComponent } from './asset-events-modal/asset-events-modal.component';

@Component({
  selector: 'lib-asset-event',
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [ListService, { provide: NgbDateAdapter, useClass: DateAdapter }],
  templateUrl: './asset-event.component.html',
  styles: [],
})
export class AssetEventComponent implements OnInit {
  data: PagedResultDto<AssetEventWithNavigationPropertiesDto> = {
    items: [],
    totalCount: 0,
  };

  filters = {} as GetAssetEventsInput;

  isFiltersHidden = true;

  selected?: AssetEventWithNavigationPropertiesDto;

  asset : AssetWithNavigationPropertiesDto;

  @ViewChild(AssetEventsModalComponent) assetEventsModal: AssetEventsModalComponent;

  constructor(
    public readonly list: ListService,
    public readonly service: AssetEventService
  ) {}

  ngOnInit() { }

  loadAssetEvents(){
    this.filters.assetId = this.asset?.asset?.id;
    const getData = (query: ABP.PageQueryParams) =>
      this.service.getList({
        ...query,
        ...this.filters,
        filterText: query.filter,
      });

    const setData = (list: PagedResultDto<AssetEventWithNavigationPropertiesDto>) => (this.data = list);

    this.list.hookToQuery(getData).subscribe(setData);
  }

  clearFilters() {
    this.filters = {} as GetAssetEventsInput;
  }

  setAsset(asset: AssetWithNavigationPropertiesDto){
    this.asset = asset;
    this.loadAssetEvents();
  }

  create() {
    if(this.asset){
      this.assetEventsModal.create(this.asset);
    }
  }

  update(record: AssetEventWithNavigationPropertiesDto) {
    this.assetEventsModal.update(record);
  }

  delete(record: AssetEventWithNavigationPropertiesDto) {
    this.assetEventsModal.delete(record);
  }
}
